import * as React from 'react'

import { AdditionalCompensationsContractsHistoryFragment } from 'generated/resources/graphql'

import type { AdditionalCompensationsContractData } from 'modules/contracts/hooks/useFetchAdditionalCompensations'
import type { CustomFieldValuesContractData } from 'modules/contracts/hooks/useFetchCustomFieldValues'

export interface ContractHistoryData {
  loading: boolean
  additionalCompensations: AdditionalCompensationsContractData
  newAdditionalCompensations: AdditionalCompensationsContractsHistoryFragment[]
  customFieldValues?: CustomFieldValuesContractData
}

const Context = React.createContext<ContractHistoryData | null | undefined>(null)

export const ContractHistoryDataProvider = ({
  additionalCompensations,
  customFieldValues,
  children,
  newAdditionalCompensations,
}: {
  additionalCompensations: AdditionalCompensationsContractData
  customFieldValues?: CustomFieldValuesContractData
  children: React.ReactNode
  newAdditionalCompensations: AdditionalCompensationsContractsHistoryFragment[]
}) => {
  const loading = (additionalCompensations.loading || customFieldValues?.loading) ?? false
  const contractData: ContractHistoryData = {
    loading,
    additionalCompensations,
    customFieldValues,
    newAdditionalCompensations,
  }

  return <Context.Provider value={contractData}>{children}</Context.Provider>
}

export const useContractHistoryDataContext = (): ContractHistoryData => {
  const contractHistoryData = React.useContext(Context)

  if (!contractHistoryData) {
    throw new Error('contractHistoryData must be used within a ContractHistoryDataProvider')
  }

  return contractHistoryData
}
